const initialState = {
    str: ''
}

const passportPlaceIssueRed = (state = initialState, action) => {
    switch(action.type){
        case 'PASSPORT_PLACE_ISSUE' : {
            return {
                ...state,
                str: action.str
            }
        }
        default: {
            return state
        }
    }
}

export default passportPlaceIssueRed